import { type SpaceKeyType } from '@/styles/space'
import FormElement from './FormElement'

import {
  type V1FormElementUiType,
  type V1FormElement,
  type V1FormElementState,
  type V1FormElementUiZipCode
} from 'mnvm-mypage-app-ts-if'
import { memo } from 'react'
import styled from 'styled-components'
import { type SelectBoxStyle } from './SelectBox/GenericFormElementSelectBox'
import { type TextFieldStyle } from './TextField/FormElementTextField'
import { type TJobPostingAdvancedSearchConditionBackup } from '@/hooks/useJobPostingAdvancedSearchConditionBackup'

interface FormContainerProps {
  formElementRowGap?: SpaceKeyType
}
const FormContainer = styled.div<FormContainerProps>`
  display: flex;
  flex-direction: column;
  gap: ${(props) =>
    props.formElementRowGap !== undefined && props.formElementRowGap};
`

export interface FormElementStyle {
  selectBox: SelectBoxStyle
  textField?: TextFieldStyle
}

interface Props {
  searchAddressByZipCode?: (
    formElementUiZipCode: V1FormElementUiZipCode,
    formElementState: V1FormElementState,
    address: string
  ) => Promise<void>
  onChange: (
    newFormElementState: V1FormElementState,
    conditionBackup?: TJobPostingAdvancedSearchConditionBackup
  ) => void
  formElementList: V1FormElement[]
  onSelectElement?: (uiType: V1FormElementUiType, element: any) => void
  formElementRowGap?: SpaceKeyType
  formElementStyle?: FormElementStyle
}

const FormElements = ({
  formElementList,
  searchAddressByZipCode,
  onChange,
  onSelectElement,
  formElementRowGap,
  formElementStyle
}: Props): JSX.Element => {
  return (
    <>
      <FormContainer formElementRowGap={formElementRowGap}>
        {formElementList?.map((formElement, index) => {
          return (
            <FormElement
              key={formElement.label}
              formElementStyle={formElementStyle}
              searchAddressByZipCode={searchAddressByZipCode}
              onChange={(
                newFormElementState: V1FormElementState,
                conditionBackup?: TJobPostingAdvancedSearchConditionBackup
              ) => {
                onChange(newFormElementState, conditionBackup)
              }}
              formElement={formElement}
              formElementState={formElement.state ?? {}}
              formElementContents={undefined}
              onSelectElement={onSelectElement}
            />
          )
        })}
      </FormContainer>
    </>
  )
}

export default memo(FormElements)
